export const ALLOWED_BODY = ['POST', 'PUT', 'PATCH'];

export const DEFAULT_MESSAGE_CODE = -1;

export const DEFAULT_REFRESH_TOKEN_ERROR = 'Token refresh failed';

export const ROUTES_TO_EXCLUDE_FROM_REFRESH = [
  'login',
  'refresh',
  'sso',
  'verify',
  'logout',
];
